// const symbols = {
//   AUD: "&#36;",
//   BGN: "&#36;",
//   BRL: "R$",
//   CAD: "$",
//   CHF: "CHF",
//   CNY: "&#x5713;",
//   CZK: "CZK",
//   DKK: "DKK",
//   EUR: "&#x20AC;",
//   GBP: "&#x00A3;",
//   HKD: "$",
//   HRK: "HRK",
//   HUF: "HUF",
//   IDR: "IDR",
//   ILS: "&#x20AA;",
//   INR: "&#x20A8;",
//   JPY: "&#x00A5;",
//   KRW: "&#x20A9;",
//   MXN: "$",
//   MYR: "MYR",
//   NOK: "kr",
//   NZD: "$",
//   PHP: "&#x20B1;",
//   PLN: "PLN",
//   RON: "RON",
//   RUB: "&#x0440;&#x0443;&#x0431;",
//   SEK: "SEK",
//   SGD: "S$",
//   TRY: "TRY",
//   ZAR: "&#x0052;"
// };

export default [
  { value: "AUD", flag: "au", text: "Australian Dollar (AUD)" },
  { value: "USD", flag: "us", text: "United States Dollar (USD)" },
  { value: "BGN", flag: "bg", text: "Bulgarian Lev (BGN)" },
  { value: "BRL", flag: "br", text: "Brazil Real (BRL)" },
  { value: "CAD", flag: "ca", text: "Canadian Dollar (CAD)" },
  { value: "CHF", flag: "ch", text: "Swiss Franc (CHF)" },
  { value: "CNY", flag: "ch", text: "Chinese Yuan (CNY)" },
  { value: "CZK", flag: "cz", text: "Czech Republic Koruna (CZK)" },
  { value: "DKK", flag: "dk", text: "Danish Krone (DKK)" },
  { value: "EUR", flag: "eu", text: "Euro (EUR)" },
  { value: "GBP", flag: "vg", text: "British Pound (GBP)" },
  { value: "HKD", flag: "hk", text: "Hong Kong Dollar (HKD)" },
  { value: "HRK", flag: "hr", text: "Croatian Kuna (HRK)" },
  { value: "HUF", flag: "hu", text: "Hungarian Forint (HUF)" },
  { value: "IDR", flag: "id", text: "Indonesian Rupiah (IDR)" },
  { value: "ILS", flag: "il", text: "Israeli New Sheqel (ILS)" },
  { value: "INR", flag: "in", text: "Indian Rupee (INR)" },
  { value: "JPY", flag: "jp", text: "Japanese Yen (JPY)" },
  { value: "KRW", flag: "kr", text: "South Korean Won (KRW)" },
  { value: "MXN", flag: "mx", text: "Mexican Peso (MXN)" },
  { value: "MYR", flag: "my", text: "Malaysian Ringgit (MYR)" },
  { value: "NOK", flag: "no", text: "Norwegian Krone (NOK)" },
  { value: "NZD", flag: "nz", text: "New Zealand Dollar (NZD)" },
  { value: "PHP", flag: "ph", text: "Philippine Peso (PHP)" },
  { value: "PLN", flag: "pl", text: "Polish Zloty (PLN)" },
  { value: "RON", flag: "ro", text: "Romanian Leu (RON)" },
  { value: "RUB", flag: "ru", text: "Russian Ruble (RUB)" },
  { value: "SEK", flag: "se", text: "Swedish Krona (SEK)" },
  { value: "SGD", flag: "sg", text: "Singapore Dollar (SGD)" },
  { value: "THB", flag: "th", text: "Thai Baht (THB)" },
  { value: "TRY", flag: "tr", text: "Turkish Lira (TRY)" },
  { value: "ZAR", flag: "za", text: "South African Rand (ZAR)" }
];



// WEBPACK FOOTER //
// ./src/common/currencies.js